import { useMemo } from "react";
import { getLabel } from "../../tools/Dictionary";
import { MdArrowDropDown, MdRemove, MdAdd, MdRule, MdHome, MdOutlineForward } from "react-icons/md";
import { RiArrowGoBackLine } from "react-icons/ri";
//MdArrowDropUp
 

const ProcessDesignerItem = (props) =>
{

  //Props
  //const IsDesktop = props.IsDesktop;
  const ReadOnly = props.ReadOnly;
  const Data = props.Data;
  const Step = props.Step;
  const OnClickDetail = props.OnClickDetail;
  const OnClickAdd = props.OnClickAdd;
  const OnClickCondition = props.OnClickCondition;

  //Memo
  const ChildrenStep = useMemo(() => {
    return Step.filter(s => s.path.length > 0 && s.path[s.path.length - 1] == Data._id);
  }, [Data, Step]);


  const displayIcon = () => {

    if (Data.path.length <= 0)
      return <MdRemove />

    return <MdArrowDropDown />;

  };

  if (!Data || !Step || Step.length == 0) return (
    <div className="page_button processdesigner_schema_add" title={getLabel("ProcessDesignerItem", "Add Step")}
      onClick={() => OnClickAdd(undefined, [])}
    >
      <MdAdd />
    </div> 
  );

  const getNavigationButtonIcon = () => {

    switch (Data.navigationButton) {
      case "Home":
        return <MdHome />
      case "Back":
        return <RiArrowGoBackLine />    
      default:
        return <MdOutlineForward />;
    }

  };


  return (
    <div className="processdesigner_item_group">
      <div className="processdesigner_item_group_row">
        {!Data.isFirst && 
          <div className="processdesigner_item_cont processdesigner_item_condition page_noselect" style={{ width: "40px", backgroundColor: (Data.condition.length > 0 ? "#9acaff" : "white")}}
            title={getLabel("ConditionDesigner", "Condition(s)")} onClick={() => OnClickCondition(Data._id)}>
            <MdRule />
          </div>
        }
        <div className={"processdesigner_item_cont " + (Data.isFirst ? "processdesigner_item_cont_home": " ")}>
          <div className="processdesigner_item_cont_icon">
            {displayIcon()}
          </div>
          <div className="processdesigner_item_cont_title" onClick={() => OnClickDetail(Data._id)}>
            {Data.title}
          </div>
          <div className="processdesigner_item_cont_action" title={getLabel("ProcessDesignerItem", "Edit")}
            onClick={() => OnClickDetail(Data._id)}>
            {getNavigationButtonIcon()}
          </div>
        </div>
        {!ReadOnly &&
          <div className="page_button processdesigner_schema_add" title={getLabel("ProcessDesignerItem", "Add Step")}
            onClick={() => OnClickAdd(Data._id, Data.path)}
          >

              <MdAdd />
          </div>
        }
      </div>
      {ChildrenStep.length > 0 &&
        <div className="processdesigner_item_cont_path">
          {ChildrenStep.map((s, index) => (
            <ProcessDesignerItem 
              ReadOnly={ReadOnly}
              Step={Step}
              Data={s}
              OnClickDetail={OnClickDetail}
              OnClickAdd={OnClickAdd}
              key={s._id}
              OnClickCondition={OnClickCondition}
            />
          ))}
        </div>      
      }
    </div>
  );

}

export default ProcessDesignerItem;